import { Form, InputGroup, Tooltip } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledFormControl = styled(Form.Control)`
  background-color: ${({ theme }) => theme.colors.inputBackgroundColor};
  font-size: 1.4rem;
  border-radius: 0;
  padding: 1.5rem;
  height: 5rem;
  border: ${({ theme }) => theme.colors.borderInput};
  &:focus {
    box-shadow: 0 0 0 0.1rem rgb(192 191 190);
    border-color: #d4d4d4;
  }
`
export const StyledPasswordInput = styled(InputGroup)`
  background-color: ${({ theme }) => theme.colors.inputBackgroundColor};
  border-radius: 0;
  border: ${({ theme }) => theme.colors.borderInput};
  button {
    background-color: ${({ theme }) => theme.colors.inputBackgroundColor};
    border: none;
  }
  input {
    border: none;
  }
`

export const StyleInputEye = styled.i<{ isChangeEyeIcon?: boolean }>`
  align-self: center;
  padding-right: ${({ isChangeEyeIcon }) => (isChangeEyeIcon ? '2.5rem' : '0.5rem')};
  padding-left: 0.5rem;
  padding-bottom: ${({ isChangeEyeIcon }) => (isChangeEyeIcon ? '0.4rem' : '')};
  position: absolute;
  z-index: 5;
  margin-left: 32rem;
`

export const StyleTooltip = styled(Tooltip)`
  .tooltip-inner {
    padding: 1rem !important;
    text-align: start;
    max-width: 30rem;
  }

  .tooltip-inner > div > h4 {
    padding-bottom: 1rem;
    border-bottom: 1px solid white;
  }

  .tooltip-inner > div > ul {
    margin-left: 1rem !important;
  }

  .tooltip {
    background-color: ${({ theme }) => theme.colors.inputBackgroundColor};
  }
`

export const StyleInfoIcon = styled.div`
  .eye-icon {
    margin-left: 0.5rem;
    place-self: center;
  }
`
